import React from 'react';
import { MUITable } from 'components/shared/MUITable';
import { createDecisionLetterColumns } from '../../lib';
import { SubmissionDocumentRow } from '../../types';

const columns = createDecisionLetterColumns();

interface Props {
  decisionLetters: SubmissionDocumentRow[];
  isLoading: boolean;
}

export const DecisionLetterTable = ({ decisionLetters, isLoading }: Props) => (
  <MUITable<SubmissionDocumentRow> columns={columns} isLoading={isLoading} tableData={decisionLetters} />
);
